export default "__VITE_ASSET__6a3d8001__"